export default "__VITE_ASSET__BvWTE2OM__"